import { getAddress } from 'viem';

const PASSKEY_OWNER_HINT_STORAGE_KEY = 'snappy.passkey-owner-hint.v1';

function getStorage(): Storage | null {
    try {
        return window.localStorage;
    } catch {
        return null;
    }
}

function removeHint(storage: Storage): void {
    try {
        storage.removeItem(PASSKEY_OWNER_HINT_STORAGE_KEY);
    } catch {
        // A storage failure leaves the owner hint unavailable, which is a cache miss.
    }
}

export function readPasskeyOwnerHint(): `0x${string}` | null {
    const storage = getStorage();
    if (!storage) return null;

    let value: string | null;
    try {
        value = storage.getItem(PASSKEY_OWNER_HINT_STORAGE_KEY);
    } catch {
        return null;
    }
    if (value === null) return null;

    try {
        return getAddress(value);
    } catch {
        removeHint(storage);
        return null;
    }
}

export function writePasskeyOwnerHint(owner: string): void {
    const storage = getStorage();
    if (!storage) return;

    let normalizedOwner: `0x${string}`;
    try {
        normalizedOwner = getAddress(owner);
    } catch {
        removeHint(storage);
        return;
    }

    try {
        storage.setItem(PASSKEY_OWNER_HINT_STORAGE_KEY, normalizedOwner);
    } catch {
        // A storage failure leaves the owner hint unavailable, which is a cache miss.
    }
}

export function clearPasskeyOwnerHint(): void {
    const storage = getStorage();
    if (storage) removeHint(storage);
}
